var _style, _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWisetackLogoRound = function SvgWisetackLogoRound(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#07C0CA;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo_lockup_1_",
    className: "st1",
    d: "M40.5,155l75.9,22.7L89,221.6c-0.6,1.3-0.8,2-0.9,2.5c-0.1,0.7,0.1,1.4,0.4,2.8 c1.2,2.1,1.2,2.1,3.2,3.4c1.1,0.4,1.6,0.5,2.1,0.5s1.2-0.1,2.4-0.4l90-35c2.1-1.3,2.1-1.3,3.4-3.5l32.6-85l23.8-6.4 c1.4-0.6,2-0.9,2.5-1.4c0.5-0.5,0.8-1.2,1.6-2.4c0.3-1.2,0.4-1.9,0.4-2.4c0-0.6-0.3-1.2-0.6-2.1l0,0l0,0c-0.6-0.9-0.9-1.4-1.4-1.9 c-0.5-0.4-0.9-0.7-2.1-1.3l-50.2-17.4c-1.7-0.3-2.7-0.4-3.5-0.1c-0.8,0.3-1.5,0.8-3,1.9l-34.2,39.3l-115,30.7 c-2.8,1.3-2.8,1.3-4.2,4.1c-0.3,1.2-0.3,1.9-0.3,2.4c0.1,0.6,0.3,1.1,0.7,2.1C38.3,153.8,38.3,153.8,40.5,155z M123.5,167.3 L64,149.5l96.6-26l0,0l47.2-12.7l-28.2,73.7l-44.9-13.5l0,0l-5.2-1.6L123.5,167.3L123.5,167.3z M128.1,181.3l-19.6,31.5l54.1-21 L128.1,181.3z M213.1,97l-36.9,10L196,84.2l28,9.9l-8.1,2.1L213.1,97L213.1,97z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWisetackLogoRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wisetack-logo-round.ea166e3b.svg";
export { ForwardRef as ReactComponent };